const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'active';
const GRID_LOADED_CLASS = 'loaded';

const selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
  productCard: '.product-card',
};

document.addEventListener('DOMContentLoaded', () => {
  var text = document.getElementsByClassName("product-recommendations");
  var len = text.length;

  if (!len) {
    initButtons();
  }

  initGrid();
});

document.addEventListener('shopify-wishlist:updated', (event) => {
  // console.log('[Shopify Wishlist] Wishlist Updated ✅', event.detail.wishlist);
  initGrid();
  syncAllWishlistButtons();
});

document.addEventListener('shopify-wishlist:init-product-grid', (event) => {
  // console.log('[Shopify Wishlist] Wishlist Product List Loaded ✅', event.detail.wishlist);
});

document.addEventListener('shopify-wishlist:init-buttons', (event) => {
  // console.log('[Shopify Wishlist] Wishlist Buttons Loaded ✅', event.detail.wishlist);
});

const fetchProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=card`;

  return fetch(productTileTemplateUrl)
    .then((res) => res.text())
    .then((res) => {
      const text = res;
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(text, 'text/html');
      const productCard = htmlDocument.documentElement.querySelector(selectors.productCard);

      if (!productCard) {
        throw new Error(`Product card not found for handle: ${handle}`);
      }

      return productCard.outerHTML;
    })
    .catch((err) => {
      console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, err);
      return '';
    });
};

const setupGrid = async (grid) => {
  const wishlist = getWishlist();
  const requests = wishlist.map(fetchProductCardHTML);
  const responses = await Promise.all(requests);
  const wishlistProductCards = responses.filter(Boolean).join(' ');

  grid.innerHTML = wishlistProductCards;
  grid.classList.add(GRID_LOADED_CLASS);

  initButtons();

  const event = new CustomEvent('shopify-wishlist:init-product-grid', {
    detail: { wishlist: wishlist }
  });

  document.dispatchEvent(event);
};

const setupButtons = (buttons) => {
  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle || false;

    if (!productHandle) {
      console.error(
        '[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.'
      );
      return;
    }

    button.classList.toggle(
      BUTTON_ACTIVE_CLASS,
      wishlistContains(productHandle)
    );
  });
};

const syncAllWishlistButtons = () => {
  const buttons = document.querySelectorAll(selectors.button);

  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle || false;
    if (!productHandle) return;

    button.classList.toggle(
      BUTTON_ACTIVE_CLASS,
      wishlistContains(productHandle)
    );
  });
};

/*
  FRAQUANE FIX — Dynamic Wishlist Delegation
  ----------------------------------------------------
  Les cartes produits peuvent être déplacées, recréées ou hydratées
  dynamiquement par le Product Tabs. Un listener attaché uniquement au
  DOMContentLoaded ne suffit donc pas.

  La délégation sur document permet à TOUS les boutons [button-wishlist],
  présents ou ajoutés plus tard, de fonctionner automatiquement.
*/
document.addEventListener('click', (event) => {
  const target = event.target;

  if (!(target instanceof Element)) return;

  const button = target.closest(selectors.button);
  if (!button) return;

  const productHandle = button.dataset.productHandle || false;

  if (!productHandle) {
    console.error(
      '[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.'
    );
    return;
  }

  event.preventDefault();
  event.stopPropagation();

  updateWishlist(productHandle);

  /*
    Synchronise tous les cœurs du même produit présents simultanément
    sur la page, y compris les cartes clonées ou déplacées.
  */
  document.querySelectorAll(selectors.button).forEach((wishlistButton) => {
    if (wishlistButton.dataset.productHandle !== productHandle) return;

    wishlistButton.classList.toggle(
      BUTTON_ACTIVE_CLASS,
      wishlistContains(productHandle)
    );
  });
});

const initGrid = () => {
  const grid = document.querySelector(selectors.grid) || false;

  if (grid) {
    setupGrid(grid);
  }
};

const initButtons = () => {
  const buttons = document.querySelectorAll(selectors.button) || [];

  if (buttons.length) {
    setupButtons(buttons);
  } else {
    return;
  }

  const event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() }
  });

  document.dispatchEvent(event);
};

const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;

  if (wishlist) {
    return wishlist.split(LOCAL_STORAGE_DELIMITER).filter(Boolean);
  }

  return [];
};

const setWishlist = (array) => {
  const wishlist = array.join(LOCAL_STORAGE_DELIMITER);

  if (array.length) {
    localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  } else {
    localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);
  }

  const event = new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: array }
  });

  updateWishlistCount();
  document.dispatchEvent(event);

  return wishlist;
};

const updateWishlist = (handle) => {
  const wishlist = getWishlist();
  const indexInWishlist = wishlist.indexOf(handle);

  if (indexInWishlist === -1) {
    wishlist.push(handle);
  } else {
    wishlist.splice(indexInWishlist, 1);
  }

  return setWishlist(wishlist);
};

const wishlistContains = (handle) => {
  const wishlist = getWishlist();
  return wishlist.includes(handle);
};

const resetWishlist = () => {
  return setWishlist([]);
};

const updateWishlistCount = () => {
  const wishlist = getWishlist();

  if (typeof window.jQuery !== 'undefined') {
    $('[data-js-wishlist-count]')
      .attr('data-js-wishlist-count', wishlist.length)
      .html(wishlist.length);

    if (wishlist.length === 0) {
      $(".wish-info").css("display", "block");
    } else {
      $(".wish-info").css("display", "none");
    }
  } else {
    document.querySelectorAll('[data-js-wishlist-count]').forEach((element) => {
      element.setAttribute('data-js-wishlist-count', String(wishlist.length));
      element.textContent = String(wishlist.length);
    });

    document.querySelectorAll('.wish-info').forEach((element) => {
      element.style.display = wishlist.length === 0 ? 'block' : 'none';
    });
  }
};

if (typeof window.jQuery !== 'undefined') {
  $(document).ready(function() {
    updateWishlistCount();
    syncAllWishlistButtons();
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    updateWishlistCount();
    syncAllWishlistButtons();
  });
}